import { Link } from 'react-router-dom';
import styled from 'styled-components';
import UserInitials from '@/trio-ui/UserInitials';

export const StyledUserInitials = styled(UserInitials)`
  width: 24px;
  height: 24px;
  min-width: 24px;
  font-size: 6px;
  margin-right: 12px;
`;

export const NameLink = styled(Link)`
  flex-grow: 1;
`;
